import axios from "axios";

// Unset → same-origin /api (nginx in production, CRA dev proxy in development)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Also attach bearer token from localStorage as a fallback (e.g. cross-site issues)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("paknet_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export function extractError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d)))
      .join(" ");
  }
  if (detail?.msg) return detail.msg;
  return err?.message || "کچھ گڑبڑ ہو گئی";
}
